import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { getDistance } from 'geolib';
import * as _ from 'lodash';
import { MapsAPILoader } from '@agm/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  data: any[] = [];
  defaultData = [] = [];
  position: {latitude: number, longitude: number};
  dLat = 41.7075;
  dLng = -86.8950;
  zoom = 10;

  results = 25;
  radius = 100;

  @ViewChild('search', {static: false})
  public searchElementRef: ElementRef;

  toUpdateCenter;

  constructor(
    private db: AngularFirestore,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ){}

  ngOnInit() {
    // this.putData();
    this.readData();

    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"]
      });

      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.position.latitude = place.geometry.location.lat();
          this.position.longitude = place.geometry.location.lng();
          this.zoom = 12;

          this.filterData();
        });
      });
    });
  }

  setCurrentLocation(){
    navigator.geolocation.getCurrentPosition(({coords}) => {
      const {latitude, longitude} = coords;

      this.position = {
        latitude,
        longitude
      }

      this.filterData();
    })
  }

  // async putData(){
  //   const promises = [];

  //   for(let item of items){
  //     const data = {
  //       address: item['ADDR'],
  //       city: item['CITY'],
  //       lat: item['Latitude'],
  //       lng: item['Longitude'],
  //       name: item['Retail Name'],
  //       state: item['State'],
  //       zip: item['ZIP']
  //     }

  //     promises.push(this.db.collection('locations').add(data));
  //   }

  //   // await Promise.all(promises);

  //   console.log('Done');
  // }

  async readData(){
    this.db.collection('locations').get().pipe(map(v => v.docs.map(v => v.data()))).subscribe((data) => {
      this.defaultData = data;

      this.filterData();
    })
  }

  filterData(){
    let data = this.defaultData;

    // Filtering distance
    if(this.position){
      data = _.map(data, v => {
        v.distance = getDistance({lat: this.position.latitude, lng: this.position.longitude}, {lat: v.lat, lng: v.lng});

        return v;
      })

      data = _.sortBy(data, v => v.distance);
      data = _.filter(data, v => v.distance / 1000 <= this.radius);

      if(data.length >= 25){
        data.length = this.results;
      }
    }

    this.data = data;
  }

  centerChange({lat, lng}){
    clearTimeout(this.toUpdateCenter);

    this.toUpdateCenter = setTimeout(() => {
      this.position = {
        longitude: lng,
        latitude: lat
      }

      this.filterData();
    }, 1000);
  }

  showLocation(lat, lng){
    this.position = {
      latitude: lat,
      longitude: lng
    }

    this.zoom = 12;

    document.querySelector('.card-body').scrollTop = 0;
  }
}
